// src/components/admin/ImageTable.jsx
//=====================================
import { useState, useEffect } from "react";

const API_BASE = import.meta.env.VITE_API_URL.replace(/\/api\/?$/i, "");

export default function ImagesTable({ images, loading, onEdit, onDelete }) {
  const [selectedIds, setSelectedIds] = useState([]);
  const allSelected = images.length > 0 && selectedIds.length === images.length;

  const toggleAll = () => {
    setSelectedIds(allSelected ? [] : images.map((img) => img.id));
  };

  const toggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  // Nettoyage si des images ont été supprimées
  useEffect(() => {
    setSelectedIds((prev) =>
      prev.filter((id) => images.some((img) => img.id === id)),
    );
  }, [images]);

  if (loading)
    return (
      <p
        style={{
          fontFamily: "'Jost', sans-serif",
          fontSize: "0.8rem",
          color: "rgba(42,31,26,0.4)",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          padding: "1rem 0",
        }}
      >
        Chargement…
      </p>
    );

  return (
    <section>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "0.6rem",
        }}
      >
        <h2>Images ({images.length})</h2>

        {selectedIds.length > 0 && (
          <button
            className="btn-delete"
            onClick={() =>
              onDelete({
                bulk: true,
                ids: selectedIds,
                onDone: () => setSelectedIds([]),
              })
            }
          >
            Supprimer {selectedIds.length} image
            {selectedIds.length > 1 ? "s" : ""}
          </button>
        )}
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleAll}
                  aria-label={
                    allSelected ? "Tout désélectionner" : "Tout sélectionner"
                  }
                />
              </th>
              <th>ID</th>
              <th>Aperçu</th>
              <th>Titre</th>
              <th>Mots-clé</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {images.length === 0 && (
              <tr>
                <td
                  colSpan="6"
                  style={{
                    textAlign: "center",
                    color: "rgba(42,31,26,0.35)",
                    fontStyle: "italic",
                  }}
                >
                  Aucune image trouvée.
                </td>
              </tr>
            )}
            {images.map((img) => {
              const isChecked = selectedIds.includes(img.id);
              return (
                <tr key={img.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => toggleOne(img.id)}
                      aria-label={
                        isChecked
                          ? `Désélectionner image ${img.id}`
                          : `Sélectionner image ${img.id}`
                      }
                    />
                  </td>
                  <td>{img.id}</td>
                  <td>
                    <img
                      src={`${API_BASE}${img.url}`}
                      alt={img.title}
                      loading="lazy"
                      className="image-thumbnail"
                    />
                  </td>
                  <td>{img.title}</td>
                  <td>
                    {img.keywords ? img.keywords.split(",").join(", ") : "—"}
                  </td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => onEdit(img)}>
                        Modifier
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => {
                          onDelete(img);
                          setSelectedIds((prev) =>
                            prev.filter((x) => x !== img.id),
                          );
                        }}
                      >
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
